import { lazy } from "react";

const Grape = lazy(() => import("../components/Grape/Grape"));

const Test = () => {
  return <Grape />;
};

export default Test;
